export const SET_BILL_PAY_PAGES_FILTER = 'SET_BILL_PAY_PAGES_FILTER';

export const SET_BILL_PAY_UPSELLS_FILTER = 'SET_BILL_PAY_UPSELLS_FILTER';

export const SET_DASHBOARD_FILTER = 'SET_DASHBOARD_FILTER';

export const SET_TRANSFERS_FILTER = 'SET_TRANSFERS_FILTER';

export const SET_CUSTOM_REPORTS_FILTER = 'SET_CUSTOM_REPORTS_FILTER';
